import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 18 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 17\" id=\"icon-search\"><path d=\"M7.534.36a6.542 6.542 0 0 1 6.535 6.535 6.5 6.5 0 0 1-1.623 4.296l4.267 4.266a.435.435 0 1 1-.616.616l-4.266-4.267a6.501 6.501 0 0 1-4.297 1.623A6.542 6.542 0 0 1 1 6.895 6.542 6.542 0 0 1 7.534.36ZM7.48 12.6a5.767 5.767 0 0 0 5.761-5.76 5.768 5.768 0 0 0-5.76-5.76 5.766 5.766 0 0 0-5.76 5.76 5.767 5.767 0 0 0 5.76 5.76Z\" fill=\"currentColor\" stroke=\"currentColor\" stroke-width=\".5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol